import React, { useEffect, useState } from 'react'
import toast from "react-hot-toast";
import { Link, useParams } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import { useOrderDetailsQuery, useUpdateOrderMutation, useUpdateOrderPaymentMutation } from '../../redux/api/orderApi';

const ProcessOrder = () => {

    const [status, setStatus] = useState("");
    const [showProof, setShowProof] = useState(false);

    const params = useParams();
    const { data } = useOrderDetailsQuery(params?.id);

    const order = data?.order || {};
    const [updateOrder, { error, isSuccess }] = useUpdateOrderMutation()
    const [updateOrderPayment, { error: payError, isSuccess: paySuccess, isLoading: payLoading }] = useUpdateOrderPaymentMutation()
    const { shippingInfo, orderItems, paymentInfo, user, totalAmount, orderStatus } = order;

    useEffect(() => {
        if (orderStatus) {
            setStatus(orderStatus);
        }
    }, [orderStatus])

    useEffect(() => {
        if (error) {
            toast.error(error?.data?.message);
        }
        if (isSuccess) {
            toast.success("Order Updated");
        }
        if (payError) {
            toast.error(payError?.data?.message);
        }
        if (paySuccess) {
            toast.success("Payment status updated");
        }
    }, [error, isSuccess, payError, paySuccess]);

    const updateOrderHandler = (id) => {
        const data = { status };
        updateOrder({ id, body: data })
    }

    const togglePaymentStatus = (id) => {
        const current = String(paymentInfo?.status || '').toLowerCase();
        const next = current === 'paid' ? 'not_paid' : 'paid';
        updateOrderPayment({ id, status: next });
    }

    return (
        <AdminLayout>
            <div className="container-fluid">
                <div className="shadow-sm rounded-4 bg-body row d-flex justify-content-around p-3 ">
                    <div className="col-12 col-lg-8 order-details ">
                        <h3 className="mt-3 mb-4 fw-bold " style={{ color: "#e04f6e" }}>Order Details</h3>

                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>ID</span>
                                <span style={{ color: "#e04f6e" }}>{order?._id}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-2">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Order Status</span>
                                <span className={String(orderStatus || '').toLowerCase().includes('delivered') ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>{orderStatus}</span>
                            </div>
                        </div>

                        <h3 className="mt-5 mb-4 fw-bold" style={{ color: "#e04f6e" }}>Shipping Info</h3>
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Name</span>
                                <span style={{ color: "#e04f6e" }}>{user?.name || order?.guestInfo?.name || shippingInfo?.name}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Email</span>
                                <span style={{ color: "#e04f6e" }}>{user?.email || order?.guestInfo?.email || shippingInfo?.email}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Phone No</span>
                                <span style={{ color: "#e04f6e" }}>{shippingInfo?.phoneNo}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-start py-2">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Address</span>
                                <span style={{ color: "#e04f6e", maxWidth: 520 }}>
                                    {shippingInfo?.address}, {shippingInfo?.city}, {shippingInfo?.zipCode}, {shippingInfo?.country}
                                </span>
                            </div>
                        </div>

                        <h3 className="mt-5 mb-4 fw-bold" style={{ color: "#e04f6e" }}>Payment Info</h3>
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Status</span>
                                <span className={(String(paymentInfo?.status || '').toLowerCase() === 'paid') ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
                                    {paymentInfo?.status?.toUpperCase()}
                                </span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Method</span>
                                <span style={{ color: "#e04f6e" }}>{order?.paymentMethod}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-2">
                                <span className="fw-semibold" style={{ color: "#e04f6e" }}>Amount Paid</span>
                                <span className="fw-bold" style={{ color: "#e91e63" }}>PKR {totalAmount}</span>
                            </div>
                            {order?.paymentMethod === 'JazzCash' && paymentInfo?.screenshot && (
                                <div className="pt-2">
                                    <button
                                        className="btn update-btn btn-sm fw-semibold"
                                        onClick={() => setShowProof(true)}
                                    >
                                        View JazzCash Proof
                                    </button>
                                </div>
                            )}
                        </div>

                        <h3 className="mt-5 my-4 fw-bold" style={{ color: "#e04f6e" }}>Order Items:</h3>

                        <hr />
                        <div className="cart-item my-1">
                            {orderItems?.map((item, index) => (
                                <div
                                    key={index}
                                    className="cart-card d-flex flex-column flex-sm-row align-items-start align-items-sm-center rounded-4 p-3 mb-3 bg-white shadow-sm"
                                >
                                    <img
                                        src={item?.image}
                                        alt={item?.name}
                                        height="70"
                                        width="70"
                                        className="rounded-3 me-sm-3 mb-2 mb-sm-0 flex-shrink-0"
                                    />
                                    <div className="flex-grow-1">
                                        <Link
                                            to={`/product/${item?.product}`}
                                            className="fw-semibold text-decoration-none"
                                            style={{ color: "#e04f6e" }}
                                        >
                                            {item?.name}
                                        </Link>
                                        {item?.variant?.name ? (
                                            <div className="small text" style={{ color: "#c56f86" }}>
                                                Variant: <span className="fw-semibold">{item.variant.name}</span>
                                            </div>
                                        ) : null}
                                        {Array.isArray(item?.colors) && item.colors.length > 0 ? (
                                            <div className="small text" style={{ color: "#c56f86" }}>
                                                Selected: <span className="fw-semibold">{item.colors.join(", ")}</span>
                                            </div>
                                        ) : item?.color ? (
                                            <div className="small text" style={{ color: "#c56f86" }}>
                                                Selected: <span className="fw-semibold">{item.color}</span>
                                            </div>
                                        ) : null}
                                        <div className="text small mt-1" style={{ color: "#e04f6e" }}>
                                            {item?.quantity} × PKR {item?.price}
                                        </div>
                                    </div>
                                    <div className="price ms-sm-3 mt-2 mt-sm-0">
                                        PKR {item?.price * item?.quantity}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <hr />
                    </div>

                    <div className="col-12 col-lg-3 mt-0 pt-0 ">
                        <h4 className="my-3 fw-bold" style={{ color: "#e04f6e" }} >Status</h4>

                        <div className="mb-3">
                            <select className="form-select" name="status"
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}>
                                <option value="Processing">Processing</option>
                                <option value="Shipped">Shipped</option>
                                <option value="Delivered">Delivered</option>
                            </select>
                        </div>

                        <button className="btn View-btn " onClick={() => updateOrderHandler(order?._id)}>
                            Update Status</button>

                        <h4 className="mt-4 mb-3 fw-bold" style={{ color: "#e04f6e" }}>Payment</h4>
                        <div>
                            <button
                                className="btn View-btn "
                                disabled={payLoading}
                                onClick={() => togglePaymentStatus(order?._id)}
                            >
                                Mark as {String(paymentInfo?.status || '').toLowerCase() === 'paid' ? 'Not Paid' : 'Paid'}
                            </button>
                       </div>



                        <h4 className="mt-4 mb-3 fw-bold" style={{ color: "#e04f6e" }}>Order Invoice</h4>
                        <Link to={`/invoice/order/${order?._id}`} className="btn View-btn ">
                            <i className="fa fa-print"></i> Generate Invoice
                        </Link>
                    </div>
                </div>

                {showProof && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{ background: "rgba(0,0,0,0.6)", zIndex: 1050 }}
                        onClick={() => setShowProof(false)}
                    >
                        <div
                            className="bg-white rounded-4 shadow p-3"
                            style={{ maxWidth: "90%", maxHeight: "90%" }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="m-0 fw-bold" style={{ color: "#e04f6e" }}>JazzCash Screenshot</h6>
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowProof(false)}>Close</button>
                            </div>
                            <div className="text-center">
                                <img
                                    src={paymentInfo?.screenshot}
                                    alt="JazzCash Proof"
                                    className="img-fluid rounded-3"
                                    style={{ maxHeight: "75vh", objectFit: "contain" }}
                                />
                            </div>
                        </div>
                    </div>

                )}
            </div>

        </AdminLayout>
    )
}

export default ProcessOrder

// Modal overlay for proof
// Add at end of component return
